import resultsRedux from 'Modules/transactions/views/results/redux/reducer';
import dataDetailsRedux from 'Modules/transactions/.components/dataDetails/redux/reducer';
import transactionsDetailsRedux from 'Modules/transactions/.components/transactionsDetails/redux/reducer';

//export redux objects
export default {
	resultsRedux,
	dataDetailsRedux,
	transactionsDetailsRedux,
};